module.exports = __webpack_public_path__ + "img/pr-8.ed3b9d4d.png";